import React, { useState, useEffect } from 'react'
import { object, func, string, any } from 'prop-types'
import { Grid, Stack, Button } from '@mui/material'
import { ObrasAutores, Obras } from '../../../services/http'
import Editoras from '../../../services/http/obras/Editoras'
import CategoriasObras from '../../../services/http/obras/CategoriasObras'
import SmallTextField from '../../../components/textfield/SmallTextfield'
import { BaseAutoComplete, BaseDatePicker } from '../../../components/shared'
import Dater from '../../../services/DateFormat'
import dayjs from 'dayjs'

const CadObra = ({
  form,
  onFormChange,
  BackButton,
  submitEnd,
  submitMethod,
  handleChange = () => {},
  onStoreEnd = () => {}
}) => {
  const action = {
    method: {
      post: 'store',
      put: 'update'
    }
  }
  const [validators, setValidators] = useState({
    categoria: { color: 'default', helper: '' }
  })

  const [editoras, setEditoras] = useState([])
  const [categorias, setCategorias] = useState([])
  const [dataPub, setDataPub] = useState(dayjs())

  const formPost = async event => {
    event.preventDefault()
    checksubTitulo()

    form.titulo = form.titulo.toUpperCase()
    const response = await Obras()[action.method[submitMethod]](form, {
      notification: true,
      message: 'Sucesso ao salvar obra!'
    })

    creatObjectObrasAutores(response.data.id)
    onStoreEnd({ obra_id: response.data.id, obra_titulo: response.data.titulo })
    handleChange(event, 3)
  }

  const formPut = async event => {
    event.preventDefault()

    if (form.isbn === '' || form.isbn === null) delete form.isbn

    const { data } = await Obras(form.id)[action.method[submitMethod]](form, {
      notification: true,
      message: 'Sucesso ao editar obra!'
    })

    submitEnd({ row: data })
  }

  const checksubTitulo = () => {
    if (form.subTitulo !== undefined) {
      form.titulo = `${form.titulo}: ${form.subTitulo}`
    }
  }

  const postObrasAutores = async form => {
    await ObrasAutores().store({ obrasAutores: form })
  }

  const creatObjectObrasAutores = idObra => {
    const obrasAutoresArrayObject = form.autores_id.map(item => {
      return {
        obra_id: idObra,
        autor_id: item
      }
    })
    postObrasAutores(obrasAutoresArrayObject)
  }

  const submitOptions = {
    post: formPost,
    put: formPut,
    '': () => {}
  }

  const getCategorias = async () => {
    const { data } = await CategoriasObras().show({ per_page: -1 })
    setCategorias(data.data)
    const item = data.data.find(
      categoria => categoria.id === form.categoria_obra_id
    )
    return item
  }

  const getEditoras = async () => {
    const { data } = await Editoras().show({ per_page: -1 })

    setEditoras(data.data)
    data.data.find(editora => {
      return editora.id === form.editora_id
    })
  }
  useEffect(() => {
    getEditoras()
    getCategorias().then(res => {
      if (res !== undefined) {
        onFormChange({
          ...form,
          categoria_obra_id: res.id,
          categoria_name: res.descricao,
          categoria: res
        })
      }
    })

    const intialDate = form.data_publicacao
      ? dayjs(form.data_publicacao)
      : dayjs()

    setDataPub(Dater().formatar(intialDate, 'yyyy-mm-dd'))
    onFormChange({
      ...form,
      data_publicacao: Dater().formatar(intialDate, 'yyyy-mm-dd')
    })
  }, [])

  useEffect(() => {
    const date = form.data_publicacao ? dayjs(form.data_publicacao) : dayjs()
    if (form.data_publicacao !== dataPub) {
      setDataPub(Dater().formatar(dayjs(date), 'yyyy-mm-dd'))
    }
  }, [form])

  const procurarEditoras = () => {
    return editoras.find(editora => {
      return editora.id === form.editora_id
    })
  }

  const procurarCategoria = () => {
    return categorias.find(categoria => {
      return categoria.id === form.categoria_obra_id
    })
  }

  const editoraDefaultvalue =
    submitMethod === 'put' ? procurarEditoras() : undefined

  const categoriaDefaultValue =
    submitMethod === 'put' ? procurarCategoria() : undefined
  return (
    <form onSubmit={submitOptions[submitMethod]}>
      <Grid
        container
        spacing={2}
        sx={{ overflowY: 'scroll', maxHeight: '50vh' }}
      >
        <Grid item xs={12} md={4}>
          <SmallTextField
            disabled={submitMethod === 'put'}
            name="isbn"
            label="ISBN"
            value={form.isbn}
            onChange={({ target }) =>
              onFormChange({ ...form, isbn: target.value })
            }
            maxLength={12}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <SmallTextField
            type="text"
            label="Título"
            required
            onChange={({ target }) => {
              onFormChange({ ...form, titulo: target.value })
            }}
            value={form.titulo}
            helperText=""
            upperCase
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <SmallTextField
            disabled={submitMethod === 'put'}
            label="Autor"
            onChange={({ target }) => {
              onFormChange({ ...form, autores: target.value })
            }}
            value={form.autores}
            required
            upperCase
          />
        </Grid>
        <Grid item xs={12} md={4}>
          {submitMethod === 'post' && (
            <SmallTextField
              label="Editora"
              onChange={({ target }) => {
                onFormChange({ ...form, editora: target.value })
              }}
              value={form.editora}
              required
              upperCase
            />
          )}

          {submitMethod === 'put' && (
            <BaseAutoComplete
              defaultValue={editoraDefaultvalue}
              color="default"
              list={editoras}
              listLabel="nome"
              inputProps={{ label: 'Editora' }}
              onChange={value => {
                onFormChange({ ...form, editora_id: value.id })
              }}
            />
          )}
        </Grid>
        <Grid item xs={12} md={4}>
          <SmallTextField
            // disabled={submitMethod === 'put'}
            label="Páginas"
            type="number"
            required
            onChange={({ target }) =>
              onFormChange({ ...form, numero_pagina: target.value })
            }
            value={form.numero_pagina}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <SmallTextField
            label="Número da Edição"
            type="number"
            onChange={({ target }) =>
              onFormChange({ ...form, numero_edicao: target.value })
            }
            value={form.numero_edicao}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <SmallTextField
            label="Palavra Chave"
            required
            onChange={({ target }) => {
              onFormChange({ ...form, palavra_chave: target.value })
            }}
            value={form.palavra_chave}
          />
        </Grid>

        <Grid item xs={12} md={4}>
          {submitMethod === 'post' && (
            <SmallTextField
              color={validators.color}
              label="Categoria"
              onChange={({ target }) => {
                onFormChange({ ...form, categoria_name: target.value })
                target.helperText = 'voce mudou o valor'
                setValidators({
                  ...validators,
                  categoria: { color: 'error', helper: 'valor Inválido' }
                })
              }}
              value={form.categoria_name}
              helperText={validators.helper}
              upperCase
            />
          )}
          {submitMethod === 'put' && (
            <>
              <BaseAutoComplete
                defaultValue={categoriaDefaultValue}
                listLabel="descricao"
                list={categorias}
                inputProps={{ label: 'Categoria' }}
                onChange={value => {
                  onFormChange({
                    ...form,
                    categoria_obra_id: value.id,
                    categoria_name: value.descricao,
                    categoria: value
                  })
                }}
              />
            </>
          )}
        </Grid>

        <Grid item xs={12} md={4}>
          <BaseDatePicker
            openTo="day"
            label="Data de Publicação"
            value={dataPub}
            disabled={submitMethod === 'put'}
            onChange={event => {
              setDataPub(event)
              onFormChange({
                ...form,
                data_publicacao: Dater().formatar(event.$d, 'yyyy-mm-dd')
              })
            }}
            inputFormat="DD/MM/YYYY"
            clearable={true}
          />
        </Grid>
      </Grid>

      <Stack
        direction="row"
        spacing={2}
        sx={{ mt: 2, display: 'flex', justifyContent: 'space-between' }}
      >
        {BackButton}
        <Button type="Submit" variant="contained" color="leitura">
          Salvar
        </Button>
      </Stack>
    </form>
  )
}

CadObra.propTypes = {
  form: object.isRequired,
  onFormChange: func.isRequired,
  BackButton: any,
  submitEnd: func,
  submitMethod: string.isRequired,
  handleChange: func,
  onStoreEnd: func
}
export default CadObra
